import React from "react";
import PropTypes from "prop-types";
import { Editor } from "@tinymce/tinymce-react";

const WYSIWYG = ({
  touched,
  errors,
  name,
  noFormGroup,
  required,
  ajaxErrors,
  label,
  values,
  setFieldValue
}) => {
  const handleChange = (content, editor) => {
    setFieldValue(name, content);
  };

  return (
    <div
      className={
        (touched[name] && errors[name]) ||
        (ajaxErrors && !touched[name] && ajaxErrors[name])
          ? (noFormGroup ? "" : "form-group m-form__group ") + "has-danger"
          : noFormGroup
          ? ""
          : "form-group m-form__group "
      }
    >
      {label && (
        <label htmlFor={name}>
          {label} {required ? "*" : ""}
        </label>
      )}

      <Editor
        value={values[name]}
        init={{
          height: 500,
          menubar: false,
          relative_urls: false,
          convert_urls: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor code",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount"
          ],
          toolbar: `undo redo | formatselect fontsizeselect | bold italic link forecolor backcolor | code | 
                      alignleft aligncenter alignright alignjustify | 
                      bullist numlist outdent indent | removeformat | help`
        }}
        onEditorChange={handleChange}
      />
    </div>
  );
};

WYSIWYG.propTypes = {
  name: PropTypes.string.isRequired,
  touched: PropTypes.any,
  errors: PropTypes.any,
  className: PropTypes.string,
  label: PropTypes.string,
  noFormGroup: PropTypes.bool,
  required: PropTypes.bool,
  ajaxErrors: PropTypes.object,
  config: PropTypes.object,
  setFieldValue: PropTypes.func,
  values: PropTypes.object
};

export default WYSIWYG;
